/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import ModalContainer from "../../../../components/modal_popup";
import {
  DMMMYYYY_formate,
  MyModal,
  capitalizeWords,
  decryptedAdminID,
  emailValidation,
  mailFromOptions,
} from "../../../../utility";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  Autocomplete,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import {
  GetAllAdminDetails,
  GetInterviewListByJobId,
  getInterviewSchuledbyJobId,
  PutCandidateName,
  sendInterviewAlertToCompany,
  SendInterviewAlertToEmployer,
} from "../../../../apiServices";
import { useEffect, useState } from "react";
import { IoClose, IoSendSharp } from "react-icons/io5";
import SuccessTick from "../../../../components/success_tick";
import { useSelector } from "react-redux";
import { TiTick, TiTickOutline } from "react-icons/ti";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { HiPencilAlt } from "react-icons/hi";
import { AiOutlineClose } from "react-icons/ai";

const SendInterviewEmailAlert = ({ companyName, jobId, emailId, onClose }) => {
  // const [showPopup, setShowPopup] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const adminDetails = useSelector((state) => state.adminDetails);

  let isSuperAdmin = adminDetails.roleID == 1;

  const open = Boolean(anchorEl);

  const [showSuccess, setSuccess] = useState(false);
  const [showSuccessname, setshowSuccessname] = useState(false);

  const [showCustomDate, setShowCustom] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(false);

  const [candidateList, setCandidateList] = useState();

  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const [adminName, setAdminName] = useState([]);
  const [adminid, setAdminId] = useState([]);

  const [updateName, setupdateName] = useState({
    candidateId: "",
    firstName: "",
    lastName: "",
  });

  let today = new Date();
  let tomorrow = new Date();

  const [formData, setFormData] = useState({
    emailId: emailId,
    selectedCandidateList: [],
    selectedRow: [],
    startDate: today.toISOString().split("T")[0],
    endDate: today.toISOString().split("T")[0],
    jobId: jobId,
    err: "",
    adminId: isSuperAdmin ? null : decryptedAdminID(),
    ccmailid: "",
    bccmailid: "",
  });
  useEffect(() => {
    GetAllAdminDetails().then((data) => {
      //console.log(data, "All admin details");
      const adminNames = data.map((item) => item.userName);
      const adminIds = data.map((item) => item.id);
      setAdminName(adminNames);
      setAdminId(adminIds);
    });
  }, []);

  const handleDateChange = (e) => {
    let { value } = e.target;

    tomorrow.setDate(today.getDate() + 1);

    switch (value) {
      case "Today":
        setFormData((prev) => ({
          ...prev,
          startDate: today.toISOString().split("T")[0],
          endDate: today.toISOString().split("T")[0],
        }));
        break;

      case "Tomorrow":
        setFormData((prev) => ({
          ...prev,
          startDate: tomorrow.toISOString().split("T")[0],
          endDate: tomorrow.toISOString().split("T")[0],
        }));
        break;

      case "CustomDate":
        // Handle custom date logic here if needed
        setShowCustom(true);
        break;

      default:
        break;
    }
  };

  const customDateApply = () => {
    setShowCustom(false);
  };

  const handleCustomDate = (e, type) => {
    //console.log(e.target.value, type);
    setFormData((prev) => ({
      ...prev,
      [type]: e.target.value,
    }));
  };

  const handleCheckboxChange = (event, rowId) => {
    const isChecked = event.target.checked;

    setFormData((prev) => {
      let prevCandidateList = [...prev.selectedRow];

      if (isChecked) {
        if (!prevCandidateList.includes(rowId)) {
          prevCandidateList.push(rowId);
        }
      } else {
        prevCandidateList = prevCandidateList.filter((el) => el != rowId);
      }

      return {
        ...prev,
        selectedRow: [...prevCandidateList],
        err: "",
      };
    });
  };

  // const handleInputChange = (field, value) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [field]: value,
  //     err: "",
  //   }));
  // };

  // const validateForm = () => {
  //   let noError = 0;
  //   if (emailValidation(formData.emailId) && formData.selectedRow.length > 0) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       err: "",
  //     }));
  //   }

  //   if (!emailValidation(formData.emailId)) {
  //     setFormData((prev) => ({ ...prev, err: "Please enter valid email" }));
  //     noError++;
  //   }

  //   if (!formData.selectedRow.length > 0) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       err: "Please select any of the candidate",
  //     }));
  //     noError++;
  //   }

  //   if (
  //     !formData.selectedRow.length > 0 &&
  //     !emailValidation(formData.emailId)
  //   ) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       err: `Please enter valid email and select any of the candidate`,
  //     }));
  //     noError++;
  //   }

  //   if (!formData.adminId) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       err: `Please select any mail from`,
  //     }));
  //     noError++;
  //   }
  //   return noError;
  // };

const handleInputChange = (field, value) => {
  setFormData((prev) => ({
    ...prev,
    [field]: value,
    err: "",
  }));
};

const emailRegex =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const emailValidation = (email) => emailRegex.test(email);

const validateForm = () => {
  let noError = 0;
  const { emailId, selectedRow, adminId, ccmailid, bccmailid } = formData;

  // Validate main company email
  if (!emailValidation(emailId)) {
    setFormData((prev) => ({
      ...prev,
      err: "Please enter a valid company email",
    }));
    noError++;
  }

  // ✅ Validate CC (if provided)
  if (ccmailid?.trim()) {
    const ccList = ccmailid.split(",").map((el) => el.trim()).filter(Boolean);
    const invalidCC =
      ccList.length === 0 ||
      ccList.some((email) => !emailValidation(email));

    if (invalidCC) {
      setFormData((prev) => ({
        ...prev,
        err: "One or more CC email addresses are invalid",
      }));
      noError++;
    }
  }

  // ✅ Validate BCC (if provided)
  if (bccmailid?.trim()) {
    const bccList = bccmailid.split(",").map((el) => el.trim()).filter(Boolean);
    const invalidBCC =
      bccList.length === 0 ||
      bccList.some((email) => !emailValidation(email));

    if (invalidBCC) {
      setFormData((prev) => ({
        ...prev,
        err: "One or more BCC email addresses are invalid",
      }));
      noError++;
    }
  }

  // Validate candidate selection
  if (!selectedRow.length) {
    setFormData((prev) => ({
      ...prev,
      err: "Please select at least one candidate",
    }));
    noError++;
  }

  // Validate mail from
  if (!adminId) {
    setFormData((prev) => ({
      ...prev,
      err: "Please select 'Mail From'",
    }));
    noError++;
  }

  return noError;
};


// ✅ Handle form submission
const handleSubmit = () => {
  if (validateForm() === 0) {
    try {
      setEnableSubmit(true);

      const payload = {
        ...formData,
        cc: formData.ccmailid
          ? formData.ccmailid.split(",").map((email) => email.trim()).filter(Boolean)
          : [],
        bcc: formData.bccmailid
          ? formData.bccmailid.split(",").map((email) => email.trim()).filter(Boolean)
          : [],
      };

      sendInterviewAlertToCompany(payload)
        .then((res) => {
          setSuccess(true);
        })
        .catch((err) => {
          setSuccess(false);
          if (err?.status === 500) {
            setFormData((prev) => ({
              ...prev,
              err: "Mail configuration not found. Please contact the developer team.",
            }));
          }
        })
        .finally(() => {
          setTimeout(() => {
            setSuccess(false);
            setEnableSubmit(false);
            onClose();
          }, 3000);
        });
    } catch (error) {
      alert("Email cannot be sent: " + error);
    }
  }
};


  // const handleSubmit = (e) => {
  //   if (validateForm() == 0) {
  //     try {
  //       setEnableSubmit(true);
  //       sendInterviewAlertToCompany(formData)
  //         .then((res) => {
  //           setSuccess(true);
  //         })
  //         .catch((err) => {
  //           setSuccess(false);
  //           // console.log(err,"kkkkkkkkokoko");
            
  //           if (err?.error === "Admin mail config not found") {
  //             setFormData((prev) => ({
  //               ...prev,
  //               err: "Mail configuration not found. Please contact the developer team.",
  //             }));
  //           }

  //           // alert("Email can't send " + err);
  //         })
  //         .finally(() => {
  //           setTimeout(() => {
  //             setSuccess(false);
  //             setEnableSubmit(false);
  //           }, [3000]);
  //         });
  //     } catch (error) {
  //       alert("Email can not send" + error);
  //     }
  //   }
  // };

  const handleFromAdminChange = (e) => {
    let { value } = e.target;

    setFormData((prev) => ({
      ...prev,
      adminId: value,
      err: "",
    }));
  };

  async function getCanList() {
    try {
      await getInterviewSchuledbyJobId(formData).then((res) => {
        setCandidateList(res);
        // console.log(res, "interview");
      });
    } catch (error) {
      alert("somthing went wrong GetInterviewListByJobId " + error);
    }
  }
  useEffect(() => {
    getCanList();
  }, [formData.startDate, formData.endDate]);

  const columns = [
    { id: "name", label: "Candidate Name", minWidth: 170 },

    {
      id: "ScheduledBy",
      label: "Scheduled By",
      minWidth: 170,
      align: "left",
      format: (value) => value.toLocaleString("en-US"),
    },
    {
      id: "ScheduledOn",
      label: "Scheduled On",
      minWidth: 170,
      align: "left",
      format: (value) => value.toLocaleString("en-US"),
    },
  ];
  const startEditing = (candidate) => {
    setupdateName({
      candidateId: candidate.can_id.candidate_id,
      firstName: candidate.can_id.first_name,
      lastName: candidate.can_id.last_name,
    });
    setIsEditing(true); // Show the editing interface
  };

  const handleNameChange = (e) => {
    const { name, value } = e.target;
    setupdateName((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitNameChange = (id) => {
    const payload = {
      id: id,
      canFirstName: capitalizeWords(updateName.firstName),
      canLastName: capitalizeWords(updateName.lastName),
    };

    PutCandidateName(payload)
      .then(() => {
        setshowSuccessname(true);
        //console.log(payload, "updatename");
        // return GetInterviewListByJobId(formData);
        setTimeout(() => {
          setshowSuccessname(false);
          setIsEditing(false);
        }, 1000);
        getInterviewSchuledbyJobId(formData).then((res) => {
          setCandidateList(res);
        });
      })
      .catch((error) => {
        console.error(
          "There was an error updating the candidate name or fetching the updated list:",
          error
        );
      });
  };

  return (
    <>
      <MyModal>
        <ModalContainer
          zIndex={1500}
          childComponent={
            <>
              <div className="p-3" style={{ maxWidth: "", width: "80vw" }}>
                <div className="d-flex flex-row justify-content-between align-items-center mb-3">
                  <div className="text-center" style={{ fontSize: "15px" }}>
                    Send Interview Email Alert to <b> {companyName}</b>
                  </div>

                  <div className="d-flex flex-row  align-items-center gap-2">
                    {/* <div>
                      <b>Filter by :</b>
                    </div>{" "} */}
                    <div>
                      <select
                        onChange={(e) => {
                          handleDateChange(e);
                        }}
                        className="form-control"
                        style={{ width: "auto", cursor: "pointer" }}
                      >
                        <option disabled value="">
                          Interview Date
                        </option>
                        <option value="Today">Today</option>
                        <option value="Tomorrow">Tomorrow</option>
                        <option value="CustomDate">Custom date</option>
                      </select>{" "}
                    </div>
                    <button className="btn btn-danger" onClick={onClose}>
                      <AiOutlineClose />
                    </button>
                  </div>
                </div>
                <div>
                  <div className="row">
                    <div className="col-sm-8">
                      {" "}
                      <TableContainer sx={{ maxHeight: 440 }}>
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead style={{ background: "#169c50" }}>
                            <TableRow>
                              <TableCell padding="checkbox">
                                <div className="d-grid justify-content-center"></div>
                              </TableCell>
                              {columns.map((column) => (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  style={{ minWidth: column.minWidth }}
                                >
                                  {column.label}
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {" "}
                            {candidateList &&
                              candidateList.interviews.map((row) => {
                                return (
                                  <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={row.id}
                                  >
                                    <TableCell padding="checkbox">
                                      <div className="d-grid justify-content-center">
                                        <input
                                          style={{
                                            // padding: "6px",
                                            height: "17px",
                                            width: "17px",
                                          }}
                                          type="checkbox"
                                          onInput={(event) => {
                                            handleCheckboxChange(
                                              event,
                                              row.can_id.candidate_id
                                            );
                                          }}
                                        />
                                      </div>
                                    </TableCell>
                                    {/* <TableCell>{row.candidateName} </TableCell> */}
                                    <TableCell>
                                      <div>
                                        {row.can_id.first_name +
                                          " " +
                                          row.can_id.last_name}
                                        <button
                                          className="btn"
                                          onClick={() => {
                                            startEditing(row);
                                            setIsEditing(true);
                                            setEditingId(row);
                                          }}
                                          style={{
                                            borderRadius: "50%",
                                            fontSize: "20px",
                                          }}
                                        >
                                          <HiPencilAlt
                                            style={{ color: "#1b56ae" }}
                                          />
                                        </button>
                                      </div>
                                      {/* {isEditing &&
                                  updateName.candidateId ===
                                    row.canInterviewsModel.canId ? (
                                    
                                  ) : (
                                    <div>
                                      {row.firstName + " " + row.lastName}
                                      <button
                                        className="btn"
                                        onClick={() => setIsEditing(true)}
                                        style={{
                                          borderRadius: "50%",
                                          fontSize: "20px",
                                        }}
                                      >
                                        <HiPencilAlt
                                          style={{ color: "#1b56ae" }}
                                        />
                                      </button>
                                    </div>
                                  )} */}
                                    </TableCell>

                                    <TableCell>
                                      {/* {adminName[adminid.indexOf(row.admin_id)]} */}
                                      {adminName.length > 0 &&
                                      adminid.includes(row.admin_id)
                                        ? adminName[
                                            adminid.indexOf(row.admin_id)
                                          ]
                                        : row.admin_name}
                                    </TableCell>
                                    <TableCell>
                                      <DMMMYYYY_formate
                                        dateValue={row.interview_date}
                                      />
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                          </TableBody>
                        </Table>

                        {candidateList &&
                          candidateList.interviews.length == 0 && (
                            <div className="text-danger text-center my-4   ">
                              No Interviews Schedeuled during this time
                            </div>
                          )}
                      </TableContainer>
                    </div>
                    <div className="col-sm-4">
                      <div className="d-flex flex-sm-column gap-2 mt-3">
                        {isSuperAdmin && (
                          <Autocomplete
                            disablePortal
                            id="mail-from-autocomplete"
                            options={mailFromOptions}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Mail From *"
                                fullWidth
                              />
                            )}
                            className="mb-2"
                            onChange={(event, newValue) => {
                              handleFromAdminChange({
                                target: {
                                  name: "fromAdminId",
                                  value: newValue ? newValue.id : "",
                                },
                              });
                            }}
                            sx={{ width: "100%" }}
                            componentsProps={{
                              popper: {
                                sx: { zIndex: 1600 },
                              },
                            }}
                          />
                        )}

                        <TextField
                          // sx={{ mx: 5 }}
                          id="outlined-multiline-flexible"
                          label="Company Email Id"
                          required
                          placeholder="Enter the company email id"
                          onChange={(event) =>
                            handleInputChange("emailId", event.target.value)
                          }
                          value={formData.emailId}
                          maxRows={4}
                          fullWidth
                        />

                        <TextField
                          // sx={{ mx: 5 }}
                          id="outlined-multiline-flexible"
                          label="CC mail Id"
                          // required
                          placeholder="Enter the CC email id"
                          onChange={(event) => {
                            const value = event.target.value;
                            if (!/\s/.test(value)) {
                              handleInputChange("ccmailid", value);
                            }
                          }}
                          className="mt-3"
                          value={formData.ccmailid}
                          maxRows={5}
                          fullWidth
                        />
                        <TextField
                          // sx={{ mx: 5 }}
                          id="outlined-multiline-flexible"
                          label="BCC mail Id"
                          // required
                          placeholder="Enter the BCC email id"
                          onChange={(event) => {
                            const value = event.target.value;
                            if (!/\s/.test(value)) {
                              handleInputChange("bccmailid", value);
                            }
                          }}
                          className="mt-3"
                          value={formData.bccmailid}
                          maxRows={5}
                          fullWidth
                        />
                        <div>
                          {formData.err && (
                            <p className="text-danger mt-2">{formData.err}</p>
                          )}
                        </div>
                        <div className="d-flex justify-content-end align-items-center mt-2">
                          <button
                            onClick={() => handleSubmit()}
                            disabled={enableSubmit}
                            style={{
                              // width: "50px",
                              // height: "50px",
                              padding: "10px 20px",
                              background: enableSubmit ? "#ccc" : "#169c50",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "10px",
                              color: "#fff",
                              cursor: enableSubmit ? "not-allowed" : "pointer",
                              border: "none",
                              opacity: enableSubmit ? 0.6 : 1,
                            }}
                            title="Send Alert"
                          >
                            Send Alert <IoSendSharp className="ms-2" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        />
      </MyModal>

      {showCustomDate && (
        <MyModal>
          <ModalContainer
            zIndex={1600}
            childComponent={
              <div
                style={{
                  minWidth: "400px",
                  width: "auto",
                }}
              >
                <>
                  <div>
                    <form>
                      <p className="text-center ">Select Custom Date </p>
                      <div className="mt-2">
                        <label htmlFor="start">From</label>
                        <input
                          className={`form-control`}
                          style={{ width: "100%" }}
                          type="date"
                          id="start"
                          onChange={(value) =>
                            handleCustomDate(value, "startDate")
                          }
                          value={formData.startDate}
                          name="trip-start"
                          min="2020-01-01"
                          max="2050-01-01"
                        />
                        {/* {validationErrors.start && (
                          <div className="invalid-feedback">
                            Start date is required.
                          </div>
                        )} */}
                      </div>
                      <div className="mt-2">
                        <label htmlFor="end">To</label>
                        <input
                          // className={`form-control ${
                          //   validationErrors.end ? "is-invalid" : ""
                          // }`}
                          className={`form-control`}
                          value={formData.endDate}
                          style={{ width: "100%" }}
                          type="date"
                          id="end"
                          onChange={(value) =>
                            handleCustomDate(value, "endDate")
                          }
                          name="trip-end"
                          min="2020-01-01"
                          max="2050-01-01"
                        />
                        {/* {validationErrors.end && (
                          <div className="invalid-feedback">
                            End date is required.
                          </div>
                        )} */}
                      </div>
                      <div className="d-flex justify-content-end mt-3 ">
                        <button
                          onClick={customDateApply}
                          style={{
                            backgroundColor: "#b2261c",
                          }}
                          className="btn rounded-pill text-white px-4  me-2"
                        >
                          Close
                        </button>
                        <button
                          onClick={customDateApply}
                          // color="primary"
                          className="btn rounded-pill text-white px-4"
                          style={{
                            backgroundColor: "#169C50",
                          }}
                        >
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                </>
              </div>
            }
          />
        </MyModal>
      )}
      {showSuccessname && (
        <MyModal>
          <ModalContainer
            zIndex={1900}
            childComponent={
              <>
                <SuccessTick HeadText="Update Successfully" />
              </>
            }
          />
        </MyModal>
      )}
      {isEditing && (
        <MyModal>
          <ModalContainer
            zIndex={1700}
            childComponent={
              <>
                {" "}
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <b>Update Candidate Name</b>
                  </div>
                  <div
                    className="btn btn-danger"
                    onClick={() => {
                      setIsEditing(false);
                    }}
                  >
                    <AiOutlineClose />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="d-flex align-items-center col-sm-12">
                    <div>
                      {" "}
                      <label htmlFor="">
                        <b>First Name : </b>
                      </label>
                      <input
                        name="firstName"
                        className="form-control mt-1"
                        value={updateName.firstName}
                        onChange={handleNameChange}
                        type="text"
                      />
                    </div>
                    <div>
                      {" "}
                      <label htmlFor="" className="ms-1 ">
                        <b>Last Name :</b>
                      </label>
                      <input
                        name="lastName"
                        className="ms-1 mt-1 form-control"
                        value={updateName.lastName}
                        onChange={handleNameChange}
                        type="text"
                      />
                    </div>
                    <button
                      className="btn"
                      style={{
                        borderRadius: "50%",
                        fontSize: "36px",
                        marginTop: "10px",
                      }}
                      title="Change candidate name"
                      onClick={() =>
                        submitNameChange(editingId.can_id.candidate_id)
                      }
                    >
                      <IoMdCheckmarkCircle style={{ color: "#169c50" }} />
                    </button>
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )}

      {showSuccess && (
        <MyModal>
          <ModalContainer
            zIndex="1700"
            childComponent={
              <>
                <SuccessTick HeadText="Interview Alert sent" />
              </>
            }
          />
        </MyModal>
      )}
    </>
  );
};

export default SendInterviewEmailAlert;
